<template>
  <div class="additionalOwnersInfo">
    <review-card name="additionalOwnersInfo" :editable="false">
      <accordion
        v-for="(owner, index) in coOwners"
        :key="index"
        class="infoBlock"
        :id="owner.id"
        :open="owner.id === idOfOpenOwner && openSection"
        @toggle="onToggle"
      >
        <div slot="title" class="title">
          <heading level="4">{{ getFullName(owner.firstName, owner.lastName) }}</heading>
          <span>{{ t('ownerSort', { order: index + 1 }) }}</span>
          <span>{{ t('ownershipTitle', { percent: owner.percentOwnership }) }}</span>
        </div>
        <heading level="4" class="titleCard">{{ t('title') }}</heading>
        <div class="data">
          <text-object :label="t('firstNameLabel')">
            {{ owner.firstName }}
          </text-object>
          <text-object :label="t('lastNameLabel')">
            {{ owner.lastName }}
          </text-object>
          <text-object :label="t('emailLabel')">
            {{ owner._extension.email }}
          </text-object>
          <text-object :label="t('homeAddressLabel')">
            <div class="address">{{ getAddress(owner) }}</div>
          </text-object>
          <text-object :label="t('primaryPhoneLabel')">
            {{ formatPhone(owner.primaryPhone) }}
          </text-object>
          <text-object :label="t('dobLabel')">
            {{ formatDate(owner.dateOfBirth) }}
          </text-object>
          <text-object :label="t('ownLabel')">
            {{ formatPercent(owner.percentOwnership) }}
          </text-object>
        </div>
      </accordion>
    </review-card>
  </div>
</template>
<script>
import ReviewCard from '@/components/ReviewCard';
import TextObject from '@/components/TextObject';
import Accordion from '@/components/Accordion';
import buildTranslators from '@/utils/build-translators';
import phone from '@/filters/phone';
import percent from '@/filters/percent';
import convertFormat from '@/utils/convert-datetime-format';
import { FRONTEND_DOB_FORMAT, BACKEND_FORMAT } from '@/constants/date-formats';

export default {
  name: 'additional-owners-info',
  components: {
    ReviewCard,
    TextObject,
    Accordion,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
    idOfOpenOwner: {
      type: [String, Number],
      required: true,
    },
    openSection: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showEditModal: false,
    };
  },
  computed: {
    coOwners() {
      return this.application.coOwners;
    },
  },
  methods: {
    formatPhone: phone,
    formatPercent: percent,
    t(key, options) {
      return buildTranslators('reviewSubmit.card.additionalOwnersInfo').t(key, options);
    },
    formatDate(dateInBackendFormat = '') {
      return convertFormat(dateInBackendFormat, BACKEND_FORMAT, FRONTEND_DOB_FORMAT);
    },
    getFullName(firstName, lastName) {
      return `${firstName} ${lastName}`;
    },
    getAddress(owner) {
      return `${owner.unitNumber} ${owner.streetNumber} ${owner.streetName} ${owner.streetType}\n ${owner.city}, ${owner.state} ${owner.postalCode}`;
    },
    onToggle({ opened, id }) {
      this.$emit('toggle', { id, opened });
    },
  },
};
</script>
<style lang="sass" scoped>
$icon-size: baseunit(1.6)

.dummy
  +mqMax($stego)
    display: none

.data
  display: grid
  grid-template-columns: minmax(0, 1fr)
  row-gap: $glass-spacing-4
  column-gap: $glass-spacing-3
  padding: $glass-spacing-2 0
  color: $font-color-dark

  +mq($stego)
    grid-template-columns: repeat(3, minmax(0, 1fr))
    padding: $glass-spacing-2 $glass-spacing-3

.icon
  margin-right: $glass-spacing-05
  width: $icon-size
  height: $icon-size

.infoBlock
  margin-bottom: $glass-spacing-3

  .title
    width: 100%
    display: grid
    grid-gap: $glass-spacing-105
    grid-template-columns: 2fr 1fr 1fr

.titleCard
  margin: $glass-spacing-105 0 $glass-spacing-3

.infoBlock:last-child
  margin-bottom: 0

.fullName
  color: $font-color-dark
  word-break: break-word

.additionalOwnersInfo
  ::v-deep
    .body
      margin-top: 0

.address
  white-space: pre-line
</style>
